import { buttonClasses, SxProps } from '@mui/material'

interface ImageGalleryButtonStyles {
  wrapper: SxProps
  button: SxProps
  buttonIcon: SxProps
  buttonText: SxProps
}

export const imageGalleryButtonStyles: ImageGalleryButtonStyles = {
  wrapper: {
    position: 'absolute',
    bottom: 10,
    right: 10,
    zIndex: 1,
  },
  button: {
    px: 1.5,
    py: 0.5,
    minWidth: 'auto',
    [`.${buttonClasses.startIcon}`]: {
      mr: 0.5,
    },
  },
  buttonIcon: {
    width: 15,
    height: 15,
    color: 'utils.gray700',
  },
  buttonText: {
    typography: 'textXsSemibold',
    mt: '1px',
  },
}
